import FilterTableUsuario from "./FilterTableUsuario";
import FilterTableEmpleado from "./FilterTableEmpleado";

const FilterTableGestionUsuarios = () => {
  return (
    <div>
      <center>
        <h2>Gestion de Usuarios y Personal</h2>
      </center>
      <section>
        <FilterTableEmpleado />
      </section>
    </div>
  );
};

export default FilterTableGestionUsuarios;
